import React, { useState } from "react"
import { useTranslation } from "react-i18next"

import { getProtectedEvent } from "../../http_service/events"

const PasswordProtected = ({ slug = "", getAuthorizedEvent, pk = "", id = "" }) => {
  const { t } = useTranslation("events")
  const [password, setPassword] = useState("")
  const [error, setError] = useState("")
  const passwordHasValue = !!password.trim()

  const onSubmit = async () => {
    try {
      const response = await getProtectedEvent(password, id)
      if (response.status === 200) {
        setPassword("")
        getAuthorizedEvent(slug)
      }
    } catch (e) {
      setError(e?.response?.data?.message || "")
    }
  }

  return (
    <div className="password-protected">
      <div className="password-protected-block">
        <h1 className="password-protected-text">{t("password.heading")}</h1>
        <h3 className="password-protected-text">{t("password.body")}</h3>
      </div>
      <input
        className="password-protected-input"
        placeholder=""
        aria-label={t("password.label")}
        onChange={e => {
          setPassword(e.target.value)
        }}
        onKeyPress={event => {
          if (event.key === "Enter" && passwordHasValue) {
            onSubmit(password)
          }
        }}
        type="password"
      />
      <p className="error-block" style={{ display: error ? "flex" : "none" }}>
        {error}
      </p>
      <button
        disabled={!passwordHasValue}
        type="button"
        className="password-submit-button"
        style={{ textTransform: "uppercase" }}
        onClick={() => {
          if (passwordHasValue) {
            onSubmit(password)
          }
        }}
      >
        {t("password.submit")}
      </button>
    </div>
  )
}

export default PasswordProtected
